var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / icon_trash_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 4H3.33333H14",
    stroke: "#E30031",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.33331 3.99967V2.66634C5.33331 2.31272 5.47379 1.97358 5.72384 1.72353C5.97389 1.47348 6.31302 1.33301 6.66665 1.33301H9.33331C9.68694 1.33301 10.0261 1.47348 10.2761 1.72353C10.5262 1.97358 10.6666 2.31272 10.6666 2.66634V3.99967M12.6666 3.99967V13.333C12.6666 13.6866 12.5262 14.0258 12.2761 14.2758C12.0261 14.5259 11.6869 14.6663 11.3333 14.6663H4.66665C4.31302 14.6663 3.97389 14.5259 3.72384 14.2758C3.47379 14.0258 3.33331 13.6866 3.33331 13.333V3.99967H12.6666Z",
    stroke: "#E30031",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66669 7.33301V11.333",
    stroke: "#E30031",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.33331 7.33301V11.333",
    stroke: "#E30031",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.e00b5b2b069c97b3a31d149f084df9e6.svg";
export { ForwardRef as ReactComponent };